// Multilingual SEO URL helpers (GEO/SEO Phase 2 Step 2).
// Language variants live at `?lang=nl|de|fr|es`; the clean URL is the
// English + x-default version. Clusters must only include languages that
// genuinely exist for the page.
const ORIGIN = "https://stoicos.ai";

export const SEO_LANGS = ["en", "nl", "de", "fr", "es"];

export function langVariantUrl(path, lang) {
  const clean = `${ORIGIN}${path}`;
  if (!lang || lang === "en") return clean;
  return `${clean}${clean.includes("?") ? "&" : "?"}lang=${lang}`;
}

export function langCanonical(path, lang) {
  return langVariantUrl(path, lang);
}

export function langAlternates(path, langs = SEO_LANGS) {
  const list = langs
    .filter((l) => SEO_LANGS.includes(l))
    .map((l) => ({ lang: l, href: langVariantUrl(path, l) }));
  if (langs.includes("en")) list.push({ lang: "x-default", href: langVariantUrl(path, "en") });
  return list;
}
